import React from "react";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Layout } from "antd";
import ErrorWidget from "./ErrorWidget";

const PageNotFound = () => {
  const { Content } = Layout;
  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <ErrorWidget />
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default PageNotFound;
